import { env } from './env';
const PREVIEW_KEY = 'baobab_preview_stack';

export type ActiveStack = {
  slug: string;
  apiUrl: string | null;
  chatUrl: string | null;
  dataSource?: string;
};

export const isPreviewBuild = (): boolean =>
  Boolean(env.stackManagerUrl);

export const getActiveStack = (): ActiveStack | null => {
  if (!isPreviewBuild()) return null;
  const raw = localStorage.getItem(PREVIEW_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as ActiveStack;
    return parsed && typeof parsed.slug === 'string' ? parsed : null;
  } catch {
    return null;
  }
};

export const setActiveStack = (s: ActiveStack): void => {
  localStorage.setItem(PREVIEW_KEY, JSON.stringify(s));
};

export const clearActiveStack = (): void => {
  localStorage.removeItem(PREVIEW_KEY);
};

export const getBackendUrl = (): string =>
  getActiveStack()?.apiUrl || env.backendUrl;

export const getChatApiUrl = (): string =>
  getActiveStack()?.chatUrl || env.chatApiUrl || '';
